export default __webpack_public_path__ + "static/media/ICONE_N-TOXICO-verde-01.5614d192.svg";